export const ALL_SURVEYS = 'ALL_SURVEYS';
export const ALL_SURVEYS_DELETE = 'ALL_SURVEYS_DELETE';
export const ALL_SURVEYS_CHANGE_STATUS = 'ALL_SURVEYS_CHANGE_STATUS';
